export default __webpack_public_path__ + "static/media/cloud-services.9221a799.svg";